import { HTTP } from './helpers/http.js'
import qs from 'qs'

const site = {
  getById(organizationId, groupId) {
    const url = `/api/v1/organizations/${organizationId}/site-groups/${groupId}`
    return HTTP.get(url)
  },

  getAll(organizationId, options) {
    const params = {
      params: options || {},
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/site-groups`
    return HTTP.get(url, params)
  },

  create(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/site-groups`
    return HTTP.post(url, data)
  },

  update(organizationId, groupId, data) {
    const url = `/api/v1/organizations/${organizationId}/site-groups/${groupId}`
    return HTTP.patch(url, data)
  },

  editSites(organizationId, groupId, data) {
    const url = `/api/v1/organizations/${organizationId}/site-groups/${groupId}/sites`
    return HTTP.patch(url, data)
  },

  getStreamSiteGroups(organizationId, options) {
    const params = {
      params: options || {},
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/stream/${organizationId}/site-groups/`
    return HTTP.get(url, params)
  },
}
export default site
